import React from 'react';
import clsx from 'clsx';
import { Card, CardContent } from '@material-ui/core/';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import GridOn from '@material-ui/icons/GridOn';
import GridOff from '@material-ui/icons/GridOff';
import DeleteIcon from '@material-ui/icons/Delete';

// import moment from 'moment';
import { expandingStyles } from './style';
import { BubbleEditor } from 'components/bubbleEditor';
import { BalloonEditor } from 'components/BalloonEditor';
import { SimpleDatePicker as DatePicker } from 'components/datePicker';

export function NewsCard(props) {
  let { isAdmin, newsItem, handleDelete, handleSave, alwaysExpanded } = props;
  const [expanded, setExpanded] = React.useState(alwaysExpanded);
  const [saved, setSaved] = React.useState(true);

  let editor;
  const setEditor = e => {
    editor = e;
    if (isAdmin === 'fubar') console.log({ editor });
  };

  const classes = expandingStyles();

  let content = newsItem?.content || '';
  let newsSplit = content && content.split('</p>');
  let intro = newsSplit && newsSplit.slice(0, 3).join('</p>');
  const paragraphCount = (newsSplit && newsSplit.length) || 0;
  const displayExpand = paragraphCount > 3;

  // example of using reference to editor
  /*
  const insertText = () => {
    if (!editor) return;
    let range = editor.getEditorSelection();
    let position = range ? range.index : 0;
    editor.editor.insertText(position, 'Hello, World! ')
  }
  */

  const handleClickDelete = () => {
    if (handleDelete) {
      handleDelete(newsItem);
    }
  };

  const handleOnChange = value => {
    newsItem.content = value;
  };

  const onSave = newsItem => {
    setSaved(true);
    if (handleSave && typeof handleSave === 'function') handleSave(newsItem);
  };

  const onEditStateClick = () => {
    if (!saved) {
      onSave(newsItem);
    } else {
      setSaved(false);
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleToggleTable = () => {
    newsItem.editorType = newsItem.editorType === 'ck5' ? 'quill' : 'ck5';
    onSave(newsItem);
  };

  const handleDateChange = value => {
    newsItem.publicationDate = value;
    onSave(newsItem);
  };

  const readOnly = !isAdmin;
  const ContextIcons = () => {
    return (
      <div className={classes.expand}>
        <DatePicker
          value={newsItem.publicationDate}
          onChange={handleDateChange}
          animateYearScrolling
          readOnly={readOnly}
          format='d.MM.yyyy.'
          style={{ verticalAlign: 'bottom', align: 'right' }}
          InputProps={{
            disableUnderline: true,
            style: { align: 'right' },
          }}
        />
        {isAdmin && !saved ? (
          <>
            <IconButton className={classes.expand} onClick={handleToggleTable} aria-label='delete'>
              {newsItem.editorType === 'ck5' ? <GridOff /> : <GridOn />}
            </IconButton>
            <IconButton className={classes.expand} onClick={handleClickDelete} aria-label='delete'>
              <DeleteIcon />
            </IconButton>
          </>
        ) : (
          ''
        )}
        {!isAdmin ? (
          <>
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label='show more'
            >
              <ExpandMoreIcon />
            </IconButton>
          </>
        ) : (
          <>
            <IconButton
              className={classes.expand}
              onClick={onEditStateClick}
              aria-expanded={expanded}
              aria-label='edit'
            >
              {!saved ? <SaveIcon /> : <EditIcon />}
            </IconButton>
          </>
        )}
        {isAdmin && saved && (
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            aria-expanded={expanded}
            onClick={handleExpandClick}
          >
            <ExpandMoreIcon />
          </IconButton>
        )}
      </div>
    );
  };

  const DisplayBalloonCard = () => {
    return (
      <>
        {expanded || (isAdmin && !saved) ? (
          <CardContent>
            <BalloonEditor
              readOnly={!isAdmin || saved}
              onChange={handleOnChange}
              initialValue={content}
              setEditor={setEditor}
            />
          </CardContent>
        ) : (
          <CardContent>
            <BalloonEditor readOnly={true} initialValue={intro} />
          </CardContent>
        )}
        <CardActions disableSpacing>
          {displayExpand || isAdmin ? <ContextIcons which='balloon' /> : ''}
        </CardActions>
      </>
    );
  };

  const DisplayCard = () => {
    const readOnly = !isAdmin || saved;
    return (
      <>
        {expanded || (isAdmin && !saved) ? (
          <CardContent>
            <BubbleEditor
              readOnly={readOnly}
              onChange={handleOnChange}
              initialValue={content}
              setEditor={setEditor}
            />
          </CardContent>
        ) : (
          <CardContent>
            <BubbleEditor readOnly={true} initialValue={intro} />
          </CardContent>
        )}
        <CardActions className={classes.actions} disableSpacing>
          {displayExpand || isAdmin ? <ContextIcons which='bubble' /> : ''}
        </CardActions>
      </>
    );
  };

  return (
    <Card className={classes.card}>
      {newsItem.editorType === 'ck5' ? <DisplayBalloonCard /> : <DisplayCard />}
    </Card>
  );
}

export default NewsCard;

/*
        <IconButton onClick={handleClickDate}>
          {moment(newsItem.publicationDate).format('DD.MM.YYYY.')}
        </IconButton>
*/
